import { isDef as c } from "../utils/index.js";
import { lockClick as f } from "./lock-click.js";
import { PopupMixin as h } from "../mixins/popup/index.js";
import g from "../icon/index.js";
import d from "../loading/index.js";
import { createNamespace as m } from "../utils/create/index.js";
var s = m("toast"),
  p = s[0],
  o = s[1];
var x = p({
  mixins: [h()],
  props: {
    icon: String,
    className: null,
    iconPrefix: String,
    loadingType: String,
    forbidClick: Boolean,
    closeOnClick: Boolean,
    message: [Number, String],
    type: {
      type: String,
      default: "text"
    },
    position: {
      type: String,
      default: "middle"
    },
    transition: {
      type: String,
      default: "van-fade"
    },
    lockScroll: {
      type: Boolean,
      default: !1
    }
  },
  data: function data() {
    return {
      clickable: !1
    };
  },
  mounted: function mounted() {
    this.toggleClickable();
  },
  destroyed: function destroyed() {
    this.toggleClickable();
  },
  watch: {
    value: "toggleClickable",
    forbidClick: "toggleClickable"
  },
  methods: {
    onClick: function onClick() {
      this.closeOnClick && this.close();
    },
    toggleClickable: function toggleClickable() {
      var e = this.value && this.forbidClick;
      this.clickable !== e && (this.clickable = e, f(e));
    },
    /* istanbul ignore next */
    onAfterEnter: function onAfterEnter() {
      this.$emit("opened"), this.onOpened && this.onOpened();
    },
    onAfterLeave: function onAfterLeave() {
      this.$emit("closed");
    },
    genIcon: function genIcon() {
      var e = this.$createElement,
        n = this.icon,
        i = this.type,
        a = this.iconPrefix,
        r = this.loadingType,
        l = n || i === "success" || i === "fail";
      if (l) return e(g, {
        class: o("icon"),
        attrs: {
          classPrefix: a,
          name: n || i
        }
      });
      if (i === "loading") return e(d, {
        class: o("loading"),
        attrs: {
          type: r
        }
      });
    },
    genMessage: function genMessage() {
      var e = this.$createElement,
        n = this.type,
        i = this.message;
      if (!(!c(i) || i === "")) return n === "html" ? e("div", {
        class: o("text"),
        domProps: {
          innerHTML: i
        }
      }) : e("div", {
        class: o("text")
      }, [i]);
    }
  },
  render: function render() {
    var e,
      n = arguments[0];
    return n("transition", {
      attrs: {
        name: this.transition
      },
      on: {
        afterEnter: this.onAfterEnter,
        afterLeave: this.onAfterLeave
      }
    }, [n("div", {
      directives: [{
        name: "show",
        value: this.value
      }],
      class: [o([this.position, (e = {}, e[this.type] = !this.icon, e)]), this.className],
      on: {
        click: this.onClick
      }
    }, [this.genIcon(), this.genMessage()])]);
  }
});
export { x as default };
